import { Alert, Button, Col, Descriptions, Popconfirm } from "antd";
import { damageCaseIssuerTypesOptions, damageCaseStatusOptions, enmDamageCaseStatus, enmEvaluationMethods, enmEvaluationStatus, enmFinancialStatus, enmPolicyholderResponseTypes, evaluationMethodsOptions, evaluationStatusOptions, IDamageCase, IDamageCaseFetchingInfo, IDamageCaseInitialData, IDamageCaseProps, IDamageCaseStates } from "../../baseInfo/damageCase/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { enmControlType, enmEntityManagerState, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IEvaluationComponentFormProps } from "../../evaluation/damageCaseEvaluator/evaluationComponent";
import * as EvaluationComponents from "../../evaluation/damageCaseEvaluator/components";
import dayjs from 'dayjs';
import { enmOrderingType, ICallOptions, IResultSet } from "../../components/infrastructure/models";
import { PolicyholderConfirmation } from "./policyholderConfirmation";
import { DamageCaseCreate } from "./damageCaseCreate";
import { UploadDocuments } from "./uploadDocuments";
import { ReactNode } from "react";
import { Core } from "../../components/infrastructure/core";
import { IDocumentCheck, IDocumentCheckFormProps } from "../../evaluation/damageCaseEvaluator/documentCheck";
import { AttachmentDownloader } from "../../baseInfo/attachment/attachmentDownloader";
import AppContext, { AppContextProps } from "../../components/infrastructure/appContext";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import SimpleMap from "../../components/map";
import { IDamageEstimation } from "../../evaluation/damageCaseEvaluator/damageEstimation";
import { IPolicyholderConfirmationFormProps } from "../../evaluation/damageCaseEvaluator/policyholderConfirmation";
import { enmContactStatus } from "../../evaluation/damageCaseEvaluator/interfaces";
import { InfoCircleFilled } from "@ant-design/icons";
import { TriesNames } from "../../evaluation/damageCaseEvaluator";
import { DamageType } from "../../baseInfo/damageType";

export class DamageCasePolicyholder extends BaseEntityManager<IDamageCase, IDamageCaseProps, IDamageCaseStates, IDamageCaseFetchingInfo, IDamageCaseInitialData>{
    scrolled: boolean = false;
    static initMetadata = (): IMetadata => {
        return {
            title: "لیست پرونده های خسارت بیمه",
            name: "DamageCasePolicyholder",
            Properties: [
                {
                    title: "صادر کننده خسارت",
                    dataIndex: "IssuerType",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseIssuerTypesOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پرونده",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "دلیل خسارت",
                    dataIndex: "DamageReason",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "نوع خسارت",
                    dataIndex: "DamageTypeId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    lookup: {
                        lookupComponent: DamageType,
                        lookupDisplayFields: ["Name"],
                        showButton: false,
                        dropdownDisplayFields: ["Name"],
                        lookupProperty: "DamageType"
                    },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: (_, record: IDamageCase) => damageCaseStatusOptions.map(o => {
                            if (!record)
                                return { title: o.title, value: o.value };
                            if (record.Status === enmDamageCaseStatus.ReceiveDepreciated && record.DamageTypeId !== 2)
                                return { title: 'در انتظار تایید انتقال مالکیت', value: o.value };
                            else if (record.Status === enmDamageCaseStatus.ReceiveDepreciated && record.DamageTypeId === 2)
                                return { title: 'در انتظار ارسال داغی توسط مشتری', value: o.value };
                            return { title: o.title, value: o.value };
                        })
                    },
                    disabled: true,
                    filterable: true,
                    width: 200
                },
                {
                    title: "وضعیت ارزیابی",
                    dataIndex: "EvaluationStatus",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: (_: any, record: IDamageCase) => evaluationStatusOptions.map(o => {
                            if (record.EvaluationStatus === enmEvaluationStatus.DamageEstimation) {
                                let damageEstiomationTitle: string | null = null;
                                const damageEstimations = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1].Estimations;
                                if (damageEstimations.length > 0) {
                                    const currentDamageEstiomation = damageEstimations[damageEstimations.length - 1];
                                    if (currentDamageEstiomation !== null && !currentDamageEstiomation.ExpertConfirmation)
                                        damageEstiomationTitle = "منتظر تایید کارشناس زبده";
                                }
                                return { title: damageEstiomationTitle ?? o.title, value: o.value, name: o.name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected) {
                                const title = o.title + (record && record.NumberOfPreviousEvaluations < 20 ? ` (بار ${TriesNames[record.NumberOfPreviousEvaluations]}) ` : ' (بیش از بیست بار) ');
                                return { title, value: o.value, name: o.name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.ContactSetting) {
                                const methodOpt = evaluationMethodsOptions.find(m => m.value === record.EvaluationMethod);
                                const title = methodOpt?.contactSettingStatusTitle;
                                const name = methodOpt?.contactSettingCommandTitle;
                                return { title, value: o.value, name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.MakingContact) {
                                const methodOpt = evaluationMethodsOptions.find(m => m.value === record.EvaluationMethod);
                                const title = methodOpt?.makingContactStatusTitle;
                                const name = methodOpt?.makingContactCommandTitle;
                                return { title, value: o.value, name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.SendEssentials && record.DamageTypeId === 3) { // سرقت
                                return { title: 'در انتظار دریافت مدارک سرقت', value: o.value, name: 'دریافت مدارک سرقت' };
                            }
                            else {
                                return { title: o.title, value: o.value, name: o.name };
                            }
                        })
                    },
                    disabled: true,
                    filterable: false,
                    sortable: false,
                    width: 200,
                    visibility: (currentEntity: IDamageCase) => {
                        return currentEntity.Status !== enmDamageCaseStatus.Create;
                    }
                },
                {
                    title: "مرکز ارزیابی",
                    dataIndex: "EvaluatorId",
                    controlType: enmControlType.template,
                    filterable: false,
                    sortable: false,
                    renderColumn: (_: any, record: IDamageCase) => {
                        let evaluator = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    renderControl: (currentEntity: IDamageCase) => {
                        let evaluator = currentEntity.DamageCaseEvaluators[currentEntity.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    width: 200,
                    visibility: (currentEntity: IDamageCase) => {
                        return currentEntity.Status !== enmDamageCaseStatus.Create;
                    }
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "PolicyEquipmentModel.Policy.SerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.NationalCode",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.FullName",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "PolicyEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "برند",
                    dataIndex: "PolicyEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مدل",
                    dataIndex: "PolicyEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "IMEI/سریال دستگاه",
                    dataIndex: "PolicyEquipmentModel.EquipmentSerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "روش ارزیابی",
                    dataIndex: "EvaluationMethod",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: evaluationMethodsOptions.map(a => { return { name: a.name, title: a.name, value: a.value } }) },
                    disabled: true,
                    filterable: true,
                    width: 150,
                    visibility: (currentEntity: IDamageCase) => {
                        return !currentEntity.DamageReason?.includes('سرقت');
                    }
                },
                {
                    title: "تاریخ خسارت",
                    dataIndex: "DamageDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                }
            ]
        };
    }
    static contextType = AppContext;

    onInitializing() {

        this.originalOrderings = () => [
            { OrderBy: enmOrderingType.Ascending, Property: "Status" },
            { OrderBy: enmOrderingType.Ascending, Property: "EvaluationStatus" },
            { OrderBy: enmOrderingType.Descending, Property: "Id" }
        ];

        this.onDataFetching = (fetchingInfo, onViewMode) => {
            const { getUserInfo } = this.context as AppContextProps;
            const userInfo = getUserInfo();

            fetchingInfo.PolicyholderId = userInfo?.extraVariables['PolicyholderId'];
            fetchingInfo.LoadNavigations = onViewMode;
        };

        if (this.props.defaultDamageCaseId) {
            this.metadata.title = "پرونده جاری";
            this.originalFilter = () => ComparisonFilter.Equal<IDamageCase>(d => d.Id, this.props.defaultDamageCaseId);
        }
        else {

            this.searchable = true;
            this.searchArea = {
                columnsPerRow: 2
            };

            const createDamageCaseButton = (<Button key="createDamageCaseButton" type="primary" onClick={() => this.createDamage()}>ثبت خسارت جدید </Button>);
            this.extraHeaderButtons = () => [createDamageCaseButton];
        }

        this.extraHeaderNodes = () => {
            return (
                this.state.state === enmEntityManagerState.List && <Alert
                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                    message={
                        <>
                            <span>بیمه گزار/مشتری گرامی، لطفا جهت مشاهده جزئیات و پیگیری خسارت، روی ردیف مورد نظر کلیک نمایید</span>
                        </>
                    }
                    type="info"
                    icon={<InfoCircleFilled className="blink" />}
                    showIcon
                />
            );
        };

        this.extraViewNode = () => {
            let damageCaseEvaluatorId: number | undefined = undefined;
            let steps: React.ReactNode[] = [];

            const { currentEntity, evaluationSteps } = this.state;
            if (!currentEntity)
                return steps;

            const needUserAction = currentEntity.EvaluationStatus === enmEvaluationStatus.DefectiveDocuments
                || currentEntity.EvaluationStatus === enmEvaluationStatus.PolicyholderConfirmation;

            currentEntity.DamageCaseEvaluators.forEach(damageCaseEvaluator => {
                if (damageCaseEvaluator.Id !== damageCaseEvaluatorId) {
                    damageCaseEvaluatorId = damageCaseEvaluator.Id;
                    let evaluator = damageCaseEvaluator.Evaluator;
                    steps.push(
                        <div key={(damageCaseEvaluator as any).RowGuid} className="box box-blue" style={{ marginBottom: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <Descriptions>
                                        <Descriptions.Item><b>تخصیص ارزیاب</b></Descriptions.Item>
                                        <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(damageCaseEvaluator.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                        <Descriptions.Item label="کاربر">{damageCaseEvaluator.Creator?.FullName ?? 'کارشناس پرونده خسارت'}</Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <div style={{ padding: 20 }}>
                                        <label>مرکز ارزیابی</label>
                                        <p>{evaluator.NationalCode + " " + evaluator.FullName}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }

                evaluationSteps.filter(s => s.DamageCaseEvaluatorId === damageCaseEvaluatorId)
                    .forEach((s, i) => {
                        const evaluationMethod = this.state.currentEntity?.EvaluationMethod;

                        if (s.Substatus === enmEvaluationStatus.DamageEstimation && (s as IDamageEstimation).ExpertConfirmation !== true && (s as IDamageEstimation).ExpertConfirmation !== false)
                            return;

                        let title = evaluationStatusOptions.find(o => o.value === s.Substatus)?.name;

                        const evaluationMethodChanged = !!evaluationSteps.find((v, vIndex) => v.ContactStatus === enmContactStatus.EvaluationMethodToPolicyholderInPerson && i <= vIndex);
                        if (s.Substatus === enmEvaluationStatus.ContactSetting) {
                            title = evaluationMethodsOptions.find(m => (evaluationMethodChanged && m.value === enmEvaluationMethods.VideoCall) || m.value === evaluationMethod)?.contactSettingCommandTitle;
                        }
                        if (s.Substatus === enmEvaluationStatus.MakingContact) {
                            title = evaluationMethodsOptions.find(m => (evaluationMethodChanged && m.value === enmEvaluationMethods.VideoCall) || m.value === evaluationMethod)?.makingContactCommandTitle;
                        }

                        let repeatedStep = !!evaluationSteps.find((v, vIndex) => v.Substatus === s.Substatus && i > vIndex);
                        if (repeatedStep)
                            title += ' (مجدد) ';
                        let dateTime = dayjs(s.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm");
                        let history: React.ReactNode;
                        let formName = enmEvaluationStatus[Number(s.Substatus)] + "Form";
                        let formProps: IEvaluationComponentFormProps<any> = {
                            currentEntity: s,
                            loading: false,
                            disabled: true,
                            damageCase: currentEntity!,
                            damageCaseDocumentTypeAttachments: []
                        };

                        if (s.Substatus === enmEvaluationStatus.DocumentCheck) {
                            const prevCheckCount = evaluationSteps.filter((v, vIndex) => v.Substatus === s.Substatus && i > vIndex).length;
                            const attachments = this.state.attachments.filter((_, k) => k <= prevCheckCount).flatMap(a => a);
                            (formProps as IDocumentCheckFormProps).damageCaseDocumentTypeAttachments = attachments;
                            (formProps as IDocumentCheckFormProps).numberOfPreviousEvaluations = evaluationSteps.filter((v, vIndex) => v.Substatus === enmEvaluationStatus.PolicyholderConfirmation && v.ResponseType === enmPolicyholderResponseTypes.Objection && i > vIndex).length;
                        }

                        const Component = (EvaluationComponents as any)[formName];
                        if (Component) {
                            if (formName === "PolicyholderConfirmationForm") {
                                (formProps as IPolicyholderConfirmationFormProps).policyholderPanel = true;
                                (formProps as IPolicyholderConfirmationFormProps).parent = this;
                            }

                            if (formName === "ContactSettingForm") {
                                (formProps as any).evaluationMethodChanged = evaluationMethodChanged;
                            }

                            history = (
                                <div style={{ padding: 20 }} ref={node => {
                                    if (!needUserAction && i === evaluationSteps.length - 1 && !!node && this.state.state === enmEntityManagerState.View && !this.state.loading) {
                                        node.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}>
                                    <Component key={s.RowGuid} {...formProps} />
                                </div>
                            );

                            steps.push(
                                <div key={s.RowGuid} className="box box-blue" style={{ marginBottom: 10 }}>
                                    <div className="box-title">
                                        <div className="caption">
                                            <Descriptions>
                                                <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                <Descriptions.Item label="کاربر">{s.Creator?.FullName ?? 'کارشناس پرونده خسارت'}</Descriptions.Item>
                                            </Descriptions>
                                        </div>
                                    </div>
                                    <div className="box-body form">
                                        <div className="form-body">
                                            {history}
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        else if (s.Substatus === enmEvaluationStatus.DefectiveDocuments) {
                            history = (
                                <div style={{ padding: 20 }} ref={node => {
                                    if (!needUserAction && i === evaluationSteps.length - 1 && !!node && this.state.state === enmEntityManagerState.View && !this.state.loading) {
                                        node.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}>
                                    <AttachmentDownloader key={s.RowGuid} attachments={s.DamageCaseDocumentTypes.flatMap((a: any) => a.DamageCaseDocumentTypeAttachments)} />
                                </div>
                            );
                            steps.push(
                                <div key={s.RowGuid} className="box box-blue" style={{ marginBottom: 10 }}>
                                    <div className="box-title">
                                        <div className="caption">
                                            <Descriptions>
                                                <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                <Descriptions.Item label="کاربر">{s.Creator?.FullName}</Descriptions.Item>
                                            </Descriptions>
                                        </div>
                                    </div>
                                    <div className="box-body form">
                                        <div className="form-body">
                                            {history}
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                    });
            });

            let policyholderName = currentEntity.PolicyEquipmentModel.Policy.Policyholder.FullName;

            if (currentEntity.EvaluationStatus === enmEvaluationStatus.PolicyholderConfirmation) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            بیمه گزار/مشتری گرامی، طبق نظر کارشناس محترم ارزیاب، خسارت شما بررسی گردید. خواهشمند است ضمن بررسی نتیجه "برآورد خسارت" در فرم ذیل، نظر خود را ثبت نمایید
                        </div>
                    </div>
                );
                const msg = <div key={"DamageEstimationPaymentMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.EvaluationStatus === enmEvaluationStatus.Rejected && currentEntity.Status === enmDamageCaseStatus.Evaluation) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            بیمه گزار/مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> پرونده خسارت شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span> توسط کارشناسان بیمه رد شده و قابل پرداخت نیست، جزئیات فوق را مشاهده بفرمایید.
                        </b>
                    </div>
                );
                const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected/* && currentEntity.NumberOfPreviousEvaluations === 0*/) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <b>
                            بیمه گزار/مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> پرونده خسارت تجهیزات الکترونیک به شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span> جهت بررسی بیشتر به کارشناسان شرکت بیمه ارجاع داده می‌شود.
                        </b>
                    </div>
                );
                const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            //else if (currentEntity.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected && currentEntity.NumberOfPreviousEvaluations === 1) {
            //    const messageNode = (
            //        <div style={{ lineHeight: 2.2 }}>
            //            <b>
            //                بیمه گزار/مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> با توجه به اینکه پس از 2 بار ارزیابی پرونده خسارت شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span>، مبلغ پرداختی مورد تأیید شما نیست، در صورت عدم رضایت می توانید مطابق با دستورالعمل‌های شرکت بیمه سامان با شماره 8943-021 واحد امور مشتریان بخش شکایت تماس گرفته یا از طریق سایت بیمه سامان، فرم
            //                <a href="https://www.si24.ir/fa/services/form_Criticism/add/template/defaultTemplate/swd_id/54504/" target="_blank"> "انتقادات و نارضایتی‌ها" </a>
            //                را تکمیل بفرمائید.
            //            </b>
            //        </div>
            //    );
            //    const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
            //        <div style={{ direction: "rtl" }} ref={node => {
            //            if (!!node && !this.state.loading) {
            //                node.scrollIntoView({ behavior: "smooth" });
            //            }
            //        }}>
            //            <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
            //        </div>
            //    </div>
            //    steps.push(msg);
            //}

            else if (currentEntity.Status === enmDamageCaseStatus.Evaluation && currentEntity.EvaluationStatus === enmEvaluationStatus.SendEssentials) {
                let cntnt = ( // خسارت کلی
                    <b>
                        مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> با توجه به تشخیص خسارت کُلی توسط مرکز ارزیابی، خواهشمند است جعبه و متعلقات دستگاه(از قبیل شارژر، سیم شارژر، هندزفری، قلم، بند ساعت هوشمند و...) را با یادداشت نام و نام خانوادگی، کد ملّی و شماره تماس خود بر روی بسته به آدرس پستی: 1513813118 به آدرس : تهران، خیابان وزراء(خیابان خالد اسلامبولی)، نبش کوچه سیزدهم، پلاک 123، شرکت بیمه سامان، ارسال نمایید. پس از دریافت متعلقات ذکر شده پرونده خسارت بررسی و نتیجه از طریق پیام کوتاه اطلاع رسانی خواهد شد
                    </b>
                );

                if (currentEntity.DamageTypeId === 3) { // خسارت سرقت
                    if (currentEntity.DamageReason === "سرقت کُلی")
                        cntnt = (
                            <b>
                                مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> مدارک پرونده سرقت به شماره  <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span>، مورد تأیید می‌باشد. خواهشمند است مدارک خسارت اعم از اصل نامه کلانتری، اصل نامه مقام قضایی، رسید سایت همیاب 24، نامه استشهادیه محلی، فیلم دوربین مداربسته در صورت تأیید کلانتری و یا آگاهی(بر روی فلش یا سی دی)، جعبه و متعلقات دستگاه(شارژر، کابل شارژر، هندزفری و...) را با یادداشت نام و نام خانوادگی و شماره تماس خود بر روی بسته به آدرس پستی: 1513813118 به نشانی : تهران، خیابان وزراء(خیابان خالد اسلامبولی)، نبش کوچه سیزدهم، پلاک 123، شرکت بیمه سامان، ارسال نمایید. پس از دریافت مدارک سرقت و تأیید انتقال مالکیت توسط شرکت بیمه سامان، طی 15 الی 20 روز کاری (بغیر از ایام تعطیلات) مبلغ مورد توافق خسارت پرونده شماره  <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span>، به حساب اعلام شده واریز خواهد شد.
                            </b>
                        );
                    if (currentEntity.DamageReason === "سرقت با شکست حرز")
                        cntnt = (
                            <b>
                                مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> مدارک پرونده سرقت به شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span>، مورد تأیید می‌باشد. خواهشمند است مدارک خسارت اعم از اصل نامه کلانتری، اصل نامه مقام قضایی، رسید سایت همیاب 24، جعبه و متعلقات دستگاه(شارژر، کابل شارژر، هندزفری و...) را با یادداشت نام و نام خانوادگی و شماره تماس خود بر روی بسته به آدرس پستی: 1513813118 به نشانی : تهران، خیابان وزراء(خیابان خالد اسلامبولی)، نبش کوچه سیزدهم، پلاک 123، شرکت بیمه سامان، ارسال نمایید. پس از دریافت مدارک سرقت و تأیید انتقال مالکیت توسط شرکت بیمه سامان، طی 15 الی 20 روز کاری (بغیر از ایام تعطیلات) مبلغ مورد توافق خسارت پرونده شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span>، به حساب اعلام شده واریز خواهد شد.
                            </b>
                        );
                }

                const { getUserInfo } = this.context as AppContextProps;
                const { extraVariables } = getUserInfo()!;
                const zobdehLocation: { Longitude?: number; Latitude?: number; } = extraVariables['ZobdehLocation'];

                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            {cntnt}
                            {!!zobdehLocation.Longitude && !!zobdehLocation.Latitude &&
                                <div style={{ maxWidth: 400 }}>
                                    <SimpleMap
                                        disableChangeMarker={true}
                                        cityName={'تهران'}
                                        lat={zobdehLocation.Latitude}
                                        lng={zobdehLocation.Longitude}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                );

                const msg = <div key={"DamageSendEssentialsMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />

                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.Status === enmDamageCaseStatus.Evaluation && currentEntity.EvaluationStatus === enmEvaluationStatus.DamageEstimation && currentEntity.ReceiveDepreciated === true) {
                let cntnt = 
                    
                        currentEntity.DamageTypeId === 3
                        ? <b>بیمه‌گزار/مشتری گرامی، <span style={{ color: "darkgray" }}>{policyholderName}</span>، مدارک سرقت پرونده <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span> دریافت گردید. پس از بررسی مدارک ارائه شده نتیجه از طریق پیامک کوتاه اطلاع رسانی خواهد شد. از صبر و شکیبائی شما سپاسگزاریم.</b>
                        : <b>بیمه‌گزار/مشتری گرامی، <span style={{ color: "darkgray" }}>{policyholderName}</span>، دستگاه و متعلقات پرونده خسارت <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span> دریافت گردید. پس از بررسی مدارک ارائه شده نتیجه از طریق پیامک کوتاه اطلاع رسانی خواهد شد. از صبر و شکیبائی شما سپاسگزاریم.</b>
                ;
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        {cntnt}
                    </div>
                );
                const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.Status === enmDamageCaseStatus.ReceiveDepreciated && currentEntity.EvaluationStatus === enmEvaluationStatus.EvaluationComplete && currentEntity.DamageTypeId === 2) { // خسارت های جزئی
                let cntnt = (
                    <b>
                        بیمه گزار/مشتری گرامی، آقا/خانم <span style={{ color: "darkgray" }}>{policyholderName}</span> خواهشمند است ضمن انجام تعمیرات در مرکز دلخواه، فاکتور ممهور و داغی به آدرس پستی: 1513813118 به آدرس : تهران، خیابان وزراء(خیابان خالد اسلامبولی)، نبش کوچه سیزدهم، پلاک 123، شرکت بیمه سامان. خواهشمند است نام و نام خانوادگی، کد ملی و شماره تماس خود را بر روی بسته ارسالی یادداشت نمایید. پس از دریافت داغی تعمیرات و فاکتور مهرشده محل تعمیر توسط شرکت بیمه سامان طی 15 الی 20 روز کاری (بغیر از ایام تعطیلات) مبلغ مورد توافق به حساب اعلام شده واریز خواهد شد
                    </b>
                );

                const { getUserInfo } = this.context as AppContextProps;
                const { extraVariables } = getUserInfo()!;
                const zobdehLocation: { Longitude?: number; Latitude?: number; } = extraVariables['ZobdehLocation'];

                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            {cntnt}
                            {!!zobdehLocation.Longitude && !!zobdehLocation.Latitude &&
                                <div style={{ maxWidth: 400 }}>
                                    <SimpleMap
                                        disableChangeMarker={true}
                                        cityName={'تهران'}
                                        lat={zobdehLocation.Latitude}
                                        lng={zobdehLocation.Longitude}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                );

                const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            else if (currentEntity.Status === enmDamageCaseStatus.Financial && (currentEntity.FinancialStatus === enmFinancialStatus.WaitingForPay || currentEntity.FinancialStatus === enmFinancialStatus.InPayProgress)) {
                const messageNode = (
                    <div style={{ lineHeight: 2.2 }}>
                        <div>
                            بیمه گزار/مشتری گرامی، مدارک خسارت شماره <span style={{ color: "darkgray" }}>{currentEntity.TicketNo}</span> توسط شرکت بیمه سامان در تاریخ {dayjs(currentEntity.ReceiveDepreciatedDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD")} دریافت و مورد تأیید می‌باشد. طی 15 الی 20 روز کاری (بغیر از ایام تعطیلات) مبلغ مورد توافق به حساب اعلام شده واریز خواهد شد.
                        </div>
                    </div>
                );
                const msg = <div key={"DamageEstimationMessage"} className="box" style={{ marginBottom: 10 }}>
                    <div style={{ direction: "rtl" }} ref={node => {
                        if (!!node && !this.state.loading) {
                            node.scrollIntoView({ behavior: "smooth" });
                        }
                    }}>
                        <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                    </div>
                </div>
                steps.push(msg);
            }
            if (needUserAction && currentEntity) {
                if (currentEntity.EvaluationStatus === enmEvaluationStatus.DefectiveDocuments) {
                    const lastStep: IDocumentCheck = evaluationSteps[evaluationSteps.length - 1];
                    const action = (
                        <div key={"DefectiveDocuments"} className="box box-blue" style={{ marginBottom: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <Descriptions >
                                        <Descriptions.Item><b>رفع نقص مدارک</b></Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <div style={{ padding: 0, direction: "rtl" }} ref={node => {
                                        if (!!node && !this.state.loading) {
                                            node.scrollIntoView({ behavior: "smooth" });
                                        }
                                    }}>
                                        <UploadDocuments
                                            key="UploadDocuments"
                                            descriptions={lastStep.Description}
                                            isChildComponent={true}
                                            ticketNo={currentEntity.TicketNo}
                                            essentialDocuments={lastStep.DefectiveDocuments.map(d => { return { Name: d.DocumentType.Name, Code: d.DocumentType.Code! }; })}
                                            onClose={this.onLookupClosed}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    steps.push(action);
                }
                else if (currentEntity.EvaluationStatus === enmEvaluationStatus.PolicyholderConfirmation) { // enmEvaluationStatus.PolicyholderConfirmation
                    const action = (
                        <div key="PolicyholderConfirmation" className="box box-blue" style={{ marginBottom: 10 }}>
                            <div className="box-title">
                                <div className="caption">
                                    <Descriptions >
                                        <Descriptions.Item style={{ padding: 10 }}><b>ثبت پاسخ بیمه گزار/مشتری</b></Descriptions.Item>
                                    </Descriptions>
                                </div>
                            </div>
                            <div className="box-body form">
                                <div className="form-body">
                                    <div style={{ padding: 0, direction: "rtl" }} ref={node => {
                                        if (!!node && !this.state.loading) {
                                            node.scrollIntoView({ behavior: "smooth" });
                                        }
                                    }}>
                                        <PolicyholderConfirmation damageCase={currentEntity!} onClose={arg => arg && arg.preventBack === true ? this.view(this.state.currentEntity!.RowGuid) : this.back()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    steps.push(action);
                }
            }

            if (currentEntity.EvaluationStatus === enmEvaluationStatus.ContactSetting) {
                let messageNode = <></>;
                if (currentEntity.EvaluationMethod === enmEvaluationMethods.PolicyholderInPerson)
                    messageNode = (
                        <div style={{ lineHeight: 2.2 }}>
                            <div>
                                بیمه گزار/مشتری گرامی، زمان، تاریخ و نحوه ارزیابی مراجعه حضوری به ارزیاب از طریق پیام کوتاه و ایمیل حضورتان اطلاع رسانی خواهد شد. لطفاً در هنگام مراجعه به ارزیاب، مدارک زیر جهت سهولت در روند ارزیابی را به همراه داشته باشید :
                            </div>
                            <ul style={{ listStyleType: 'none' }}>
                                <li>1. مدارک شناسایی (کارت ملّی یا شناسنامه)</li>
                                <li>2. در حالاتی غیر از حالات سرقت کلی، سرقت با شکست حرز و سیل و طوفان ارائه دستگاه آسیب دیده به همراه جعبه دستگاه و متعلقات الزامی است.</li>
                                <li>3. اصل سایر مدارک آپلود شده</li>
                            </ul>
                        </div>
                    );
                //else if (currentEntity.EvaluationMethod === enmEvaluationMethods.EvaluatorInPerson)
                //    messageNode = (
                //        <div style={{ lineHeight: 2.2 }}>
                //            <div>
                //                بیمه گزار/مشتری گرامی، زمان، تاریخ و نحوه ارزیابی مراجعه حضوری ارزیاب از طریق پیام کوتاه و ایمیل حضورتان اطلاع رسانی خواهد شد. لطفاً در هنگام مراجعه ارزیاب، مدارک زیر جهت سهولت در روند ارزیابی آماده گردد:
                //            </div>
                //            <ul style={{ listStyleType: 'none' }}>
                //                <li>1. مدارک شناسایی (کارت ملّی یا شناسنامه)</li>
                //                <li>2. در حالاتی غیر از حالات سرقت کلی، سرقت با شکست حرز و سیل و طوفان ارائه دستگاه آسیب دیده الزامی است.</li>
                //                <li>3. اصل سایر مدارک آپلود شده</li>
                //            </ul>
                //        </div>
                //    );
                else if (currentEntity.EvaluationMethod === enmEvaluationMethods.VideoCall)
                    messageNode = (
                        <div style={{ lineHeight: 2.2 }}>
                            بیمه گزار/مشتری گرامی، زمان، تاریخ و نحوه ارزیابی تماس تصویری از طریق پیام کوتاه، حضورتان اطلاع رسانی خواهد شد
                        </div>
                    );
                const message = (
                    <div key={"ContactSettingMessage"} className="box" style={{ marginBottom: 10 }}>
                        <div style={{ direction: "rtl" }} ref={node => {
                            if (!!node && !this.state.loading) {
                                node.scrollIntoView({ behavior: "smooth" });
                            }
                        }}>
                            <Alert type="info" style={{ marginTop: 10 }} message={messageNode} />
                        </div>
                    </div>
                );
                steps.push(message);
            }

            const evaluator = currentEntity.DamageCaseEvaluators[currentEntity.DamageCaseEvaluators.length - 1]?.Evaluator;
            if (evaluator &&
                (
                    (currentEntity.EvaluationStatus === enmEvaluationStatus.MakingContact && currentEntity.EvaluationMethod === enmEvaluationMethods.PolicyholderInPerson)
                    ||
                    (currentEntity.Status === enmDamageCaseStatus.ReceiveDepreciated && currentEntity.EvaluationStatus !== enmEvaluationStatus.EvaluationComplete && currentEntity.DamageTypeId === 2)
                )
            ) {
                const message = (
                    <div key={"MakingContactMessage"} className="box" style={{ marginBottom: 10 }}>
                        <div style={{ direction: "rtl" }} ref={node => {
                            if (!!node && !this.state.loading) {
                                node.scrollIntoView({ behavior: "smooth" });
                            }
                        }}>
                            <Alert type="info" style={{ marginTop: 10 }} message={
                                <div style={{ lineHeight: 2.2 }}>
                                    <>
                                        {(currentEntity.Status === enmDamageCaseStatus.ReceiveDepreciated && currentEntity.DamageTypeId === 2) ?
                                            <div>
                                                بیمه گزار/مشتری گرامی، شماره تماس و آدرس مرکز ارزیابی <b>{evaluator.FullName}</b> به شرح ذیل است :
                                            </div>
                                            :
                                            <>
                                                <div>
                                                    بیمه گزار/مشتری گرامی، شماره تماس و آدرس مرکز ارزیابی <b>{evaluator.FullName}</b> به شرح ذیل است. لطفاً در هنگام مراجعه به مرکز ارزیابی، مدارک زیر را جهت سهولت در روند ارزیابی به همراه داشته باشید :
                                                </div>
                                                <ul style={{ listStyleType: 'none' }}>
                                                    <li>1. مدارک شناسایی (کارت ملّی یا شناسنامه)</li>
                                                    <li>2. در حالاتی غیر از حالات سرقت کلی، سرقت با شکست حرز و سیل و طوفان ارائه دستگاه آسیب دیده به همراه جعبه دستگاه و متعلقات الزامی است.</li>
                                                    <li>3. اصل سایر مدارک آپلود شده</li>
                                                </ul>
                                            </>
                                        }
                                    </>
                                    {evaluator.Phone && <div>شماره تماس مرکز ارزیابی : <b style={{ unicodeBidi: "plaintext" }}>{evaluator.Phone.startsWith('9') ? `0${evaluator.Phone}` : `0${evaluator.Phone}`.replace(/\D+/g, '').replace(/(\d{3})(\d+)/, '$1 - $2')}</b></div>}
                                    <div>آدرس مرکز ارزیابی: <b>{evaluator.Address}</b></div>
                                    {evaluator.WorkTime && <div>ساعت کار : <b>{evaluator.WorkTime}</b></div>}
                                    {!!evaluator.Longitude && !!evaluator.Latitude &&
                                        <div style={{ maxWidth: 400 }}>
                                            <SimpleMap
                                                disableChangeMarker={true}
                                                cityName={evaluator.City?.Name}
                                                lat={evaluator.Latitude}
                                                lng={evaluator.Longitude}
                                            />
                                        </div>
                                    }
                                </div>
                            } />
                        </div>
                    </div>
                );
                steps.push(message);
            }

            return (
                <>
                    {steps}
                </>
            );
        };

        this.viewButtonTitle = () => {
            let entity = this.selectedEntity!;
            return [enmDamageCaseStatus.Create, enmDamageCaseStatus.AssignEvaluator].indexOf(entity.Status) > -1 ||
                (entity.EvaluationStatus && [enmEvaluationStatus.DocumentCheck, enmEvaluationStatus.ContactSetting, enmEvaluationStatus.DamageEstimation].indexOf(entity.EvaluationStatus) > -1)
                ? "مشاهده پرونده خسارت" : ((entity.EvaluationStatus === enmEvaluationStatus.DefectiveDocuments) ? "رفع نقص مدارک" : (((entity.EvaluationStatus === enmEvaluationStatus.PolicyholderConfirmation) ? "مشاهده نتیجه ارزیابی و اعلام نظر" : "پیگیری")));
        };

        this.renderingToolbar = () => {
            let result: ReactNode[] = [];
            let entity = this.selectedEntity!;
            if (entity.Status === enmDamageCaseStatus.Create) {
                result.push(
                    <Col key="SendToEvaluation" style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={() => this.sendToEvaluation(entity.TicketNo)}>ارسال مدارک</Button>
                    </Col>
                );
                result.push(
                    <Col key="RemoveDamageCase" style={{ marginLeft: 10 }}>
                        <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا مایلید پرونده خسارت را حذف نمایید؟"
                            onConfirm={() => this.removeDamageCase(entity.TicketNo)}>
                            <Button type="default">حذف پرونده خسارت</Button>
                        </Popconfirm>
                    </Col>
                );
            }
            return result.length ? (<> {result} </>) : (<></>);
        };

        this.setRecordClassName = record => {
            return record?.Status === enmDamageCaseStatus.Create || (!!record?.EvaluationStatus && [enmEvaluationStatus.DefectiveDocuments, enmEvaluationStatus.MakingContact, enmEvaluationStatus.PolicyholderConfirmation, enmEvaluationStatus.SendEssentials].indexOf(record.EvaluationStatus) > -1) ? 'new-record' : null;
        };
    }
    componentDidUpdate(prevProps: IDamageCaseProps, prevState: IDamageCaseStates) {
        super.componentDidUpdate(prevProps, prevState);

        if (prevProps.defaultDamageCaseId !== this.props.defaultDamageCaseId) {
            if (this.props.defaultDamageCaseId) {
                this.metadata.title = "پرونده جاری";
                this.originalFilter = () => ComparisonFilter.Equal<IDamageCase>(d => d.Id, this.props.defaultDamageCaseId);
            }
            this.fetchData();
        }
    }
    sendToEvaluation = async (ticketNo: number) => {
        let fetchOpt: ICallOptions = {
            url: "portal/checkdocuments",
            data: { ticketNo },
            onSuccess: (result: IResultSet<any>) => {
                if (!result.ValidationState.Successful)
                    return;
                const { sent, ticketNo, essentialDocuments } = result.Data as { sent: boolean; ticketNo: number; essentialDocuments?: { Name: string; Code: string; }[]; }
                if (sent) {
                    Core.successNotification('پرونده خسارت شما با موفقیت به واحد ارزیابی ارسال شد');
                    return;
                }
                else {
                    Core.warningNotification('لطفا مدارک لازم را آپلود نمائید');
                    this.uploadDocuments(ticketNo, essentialDocuments);
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    uploadDocuments = (ticketNo: number, essentialDocuments?: { Name: string; Code: string; }[]) => {
        this.addLookupForm("UploadDocuments",
            <UploadDocuments
                key="UploadDocuments"
                invokePath={this.metadata.title}
                isChildComponent={true}
                ticketNo={ticketNo}
                essentialDocuments={essentialDocuments}
                onClose={this.onLookupClosed}
                removeable={true}
                onRemove={this.removeDamageCase}
            />);
    }
    onEntityView = (entity: IDamageCase) => {
        let fetchOpt: ICallOptions = {
            url: "damagecasepolicyholder/getallevaluationsteps",
            data: { damageCaseId: entity.Id },
            onSuccess: (result: IResultSet<any>) => {
                if (!result.ValidationState.Successful)
                    return;
                const steps = (result.Data.steps as { CreateDateTime: any; }[]).sort((a, b) => a.CreateDateTime > b.CreateDateTime ? 1 : -1) ?? [];
                this.setState({ state: enmEntityManagerState.View, currentEntity: entity, evaluationSteps: steps, attachments: result.Data.attachments });
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
        return false;
    }
    createDamage = () => {
        this.addLookupForm("DamageCaseCreate",
            <DamageCaseCreate
                key="DamageCaseCreate"
                invokePath={this.metadata.title}
                isChildComponent={true}
                close={this.onLookupClosed}
            />);
    }
    removeDamageCase = async (ticketNo: number) => {
        let fetchOpt: ICallOptions = {
            url: "portal/RemoveDamageCase",
            data: { ticketNo },
            onSuccess: async result => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('پرونده خسارت شما حذف شد');
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
}